import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import { AppState } from 'src/app/@store/app.reducers';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { selectDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-modal-consultar-lesionados',
    templateUrl: './modal-consultar-lesionados.component.html',
    styleUrls: ['./modal-consultar-lesionados.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, NgClass, MatPaginator]
})
export class ModalConsultarLesionadosComponent implements OnInit, OnDestroy {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  public displayColumns = ['No', 'Nombre'];
  public datoLesionados = new MatTableDataSource<any>([]);

  private listaObservables = new Subscription();
  public selectLesionadoDatos = null;

  constructor(
    public dialogRef: MatDialogRef<ModalConsultarLesionadosComponent>,
    private store: Store<AppState>,
    private complementoWebService: ComplementoWebService,
    @Inject(MAT_DIALOG_DATA) public data: { tipoCliente: number, id_tercero : number},
    private procesosComunesService: ProcesosComunesComplementoService,
  ) {
    this.obtenerReduxState();
  }

  ngOnDestroy(): void {
    this.listaObservables.unsubscribe();
  }

  ngOnInit(): void {

  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleSiniestro]) => {
      this.consultarLesionados(siniestro);
    });
    this.listaObservables.add(subsComplemento);
  }

  closeDialog(opcion: string, valor?) {
    if (opcion == 'Cancelar') this.dialogRef.close(valor);
    if (opcion == 'Aceptar') this.dialogRef.close(valor);
  }

  seleccionarLesionado(lesionado) {
    console.log('seleccionado')
    this.selectLesionadoDatos = lesionado;
    this.closeDialog('Aceptar', this.selectLesionadoDatos);
  }

  consultarLesionados(siniestro: string) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(siniestro);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      numeroLiga: null,
      tipoCliente: this.data.tipoCliente ?? 2, //REVIEW - 
      id_tercero: this.data.id_tercero,
      id_lesionado: null
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaLesionadosServicios(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado.Lesionado.length) {
          this.datoLesionados = new MatTableDataSource(value.Resultado.Lesionado);
          this.datoLesionados.paginator = this.paginator;
        } else {
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos de los lesionados.' }));
      },
    })
  }



}
